import { render } from "./HBEAreaLocation.vue?vue&type=template&id=697b4c12&scoped=true"
import script from "./HBEAreaLocation.vue?vue&type=script&lang=js"
export * from "./HBEAreaLocation.vue?vue&type=script&lang=js"

import "./HBEAreaLocation.vue?vue&type=style&index=0&id=697b4c12&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697b4c12"]])

export default __exports__